// External libraries
import * as React from "react";
import { UitkIcon } from "uitk-react-icons";
import { inject } from "mobx-react";
import { Layer, Viewport, ViewSmall, ViewLarge } from "bernie-view";
import { useLocalization } from "@shared-ui/localization-context";

// Components
import { InfoDialog } from "../../../shared/Merchandising/Common/InfoDialog/InfoDialog";

// UTils
import { Experiment, isVariantEnabled } from "src/components/utility/experiment";
import { locKeys } from "./l10n";

// Types
import { InformationProps } from "components/flexComponents/WizardHotelPWA/typings";

const InformationText: React.FC<InformationProps> = (props) => {
  const { formatText } = useLocalization();

  const locKey = React.useMemo(
    () =>
      props.wizardState.hotelWizardState.config.useDialogTextWithoutCar
        ? locKeys.dialogTextWithoutCar
        : locKeys.dialogText,
    [props.wizardState.hotelWizardState.config.useDialogTextWithoutCar]
  );

  return (
    <div className="uitk-type-paragraph-300 l-l-padding-two xl-l-padding-two">
      <p>{formatText(locKey)}</p>
    </div>
  );
};

export const Information: React.FC<InformationProps> = inject("context")((props) => {
  const [showDialog, setShowDialog] = React.useState(false);

  const handleDialog = () => {
    setShowDialog((previousValue) => !previousValue);
  };
  const { formatText } = useLocalization();

  const isWizardRedesignEnabled = isVariantEnabled(props.context, Experiment.Flex_Blossom_Wizard_Redesign);

  return (
    <>
      <div onClick={handleDialog} data-testid="info-icon">
        <UitkIcon name="info_outline" />
      </div>

      {showDialog && isWizardRedesignEnabled && <InformationText {...props} />}

      {showDialog && !isWizardRedesignEnabled && (
        <Viewport>
          <ViewSmall>
            <Layer id="more-info-multiple-places-dialog">
              <InfoDialog
                infoText={formatText(locKeys.dialogText)}
                buttonText={formatText(locKeys.dialogButton)}
                closeDialog={handleDialog}
              />
            </Layer>
          </ViewSmall>
          <ViewLarge>
            <InformationText {...props} />
          </ViewLarge>
        </Viewport>
      )}
    </>
  );
});
